<template>
  <div class="comReportDetails">
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'comReport',
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data () {
    return {
      contractNo:"",
    }
  }
  };
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

</style>